import { useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { Popover } from '@mui/material';

import {
  AutoCompleteSelectUI,
  InputUI,
  FormErrorUI,
  FormLabelUI,
  CheckboxUI,
  ChromeColorPickerUI,
} from '../Interface';

const DocumentPiorityFields = ({ viewField, documentTypeOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4">
        <Field
          type="autocomplete"
          name="documentTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Bizonylattípus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.documentTypeId} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.documentTypeId) }}
          selectedValue={values.documentTypeId}
          selectedLabelValue={documentTypeOptions?.find((item) => item.value === values.documentTypeId)?.label || ''}
          dataset={documentTypeOptions}
          onChange={(_event, newValue) => {
            setFieldValue('documentTypeId', newValue?.value ?? null).then(() => validateField('documentTypeId'));
          }}
        />
      </div>
      <div className="col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.name) }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          type="number"
          name="visOrder"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Sorrend" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.visOrder} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.visOrder !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="defaultValue"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett" />}
          disabled={viewField}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
      <div className="md:col-span-1 col-span-4 pt-4">
        <div
          className={`${!viewField ? 'cursor-pointer' : 'cursor-not-allowed'} rounded-full shadow-[rgba(0,_0,_0,_0.54)_0px_1px_8px] w-[20px] h-[20px] mt-1`}
          style={{ background: values.color }}
          onClick={(event) => {
            if (!viewField) setAnchorEl(event.currentTarget);
          }}
        />
        <Popover
          id={open ? 'document-priority-color-popover' : undefined}
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
          transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        >
          <ChromeColorPickerUI color={values.color} onChange={(color) => setFieldValue('color', color.hex)} />
        </Popover>
      </div>
    </div>
  );
};

export default DocumentPiorityFields;
